import { render } from "./MediaTVFormInput.vue?vue&type=template&id=14ae9ca6&scoped=true&ts=true"
import script from "./MediaTVFormInput.vue?vue&type=script&lang=ts"
export * from "./MediaTVFormInput.vue?vue&type=script&lang=ts"

import "./MediaTVFormInput.vue?vue&type=style&index=0&id=14ae9ca6&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ae9ca6"]])

export default __exports__